var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-logo"},[_c('router-link',{attrs:{"to":"/"}},[(_vm.sidebarSelectedFilter.class == 'sidebar-overlay-light')?_c('img',{attrs:{"src":_vm.darkLogo,"alt":"site logo","height":"41"}}):_c('img',{attrs:{"src":_vm.appLogo,"alt":"site logo","height":"41"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }